export default __webpack_public_path__ + "static/media/welcomeBg_m.82216666.png";